var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    clipPath: "url(#clip0_2219_631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33366 14.6673C5.70185 14.6673 6.00033 14.3688 6.00033 14.0007C6.00033 13.6325 5.70185 13.334 5.33366 13.334C4.96547 13.334 4.66699 13.6325 4.66699 14.0007C4.66699 14.3688 4.96547 14.6673 5.33366 14.6673Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6667 14.6673C13.0349 14.6673 13.3333 14.3688 13.3333 14.0007C13.3333 13.6325 13.0349 13.334 12.6667 13.334C12.2985 13.334 12 13.6325 12 14.0007C12 14.3688 12.2985 14.6673 12.6667 14.6673Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.36621 1.36719H2.69954L4.47288 9.64719C4.53793 9.95043 4.70666 10.2215 4.95002 10.4138C5.19338 10.606 5.49615 10.7074 5.80621 10.7005H12.3262C12.6297 10.7 12.9239 10.596 13.1602 10.4057C13.3966 10.2154 13.561 9.95021 13.6262 9.65385L14.7262 4.70052H3.41288",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2219_631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.5b4aa5ef256185f5879b4687fd9ebd31.svg";
export { ForwardRef as ReactComponent };